import React, { memo } from 'react';
import { EVA_URL } from 'helpers/urlHelper';
import PropTypes from 'prop-types';

const EVALink = ({ ccf, odr, value }) => {
    const odrLink = `${EVA_URL}/Internal/ODR/ODR.aspx?odr_id=`;
    const ccfLink = `${EVA_URL}/Internal/CCF/CCF.aspx?ccf_id=`;
    let link = '';
    if (odr)
        link = odrLink + odr;
    else if (ccf)
        link = ccfLink + ccf;

    return (link ? <a href={link} target="_blank" rel="noopener noreferrer">{value}</a> : value || '');
}

EVALink.propTypes = {
    ccf: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    odr: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    value: PropTypes.string
};
export default memo(EVALink);
